import * as React from "react";
import { ComplaintContainer } from "../complaint/Complaint.styled";
import { ButtonSecondary } from "../login.screen/login.styled";
import { MiniNav, MoveInHeader } from "../MoveIn.screen/MoveIn.styled";
import { TabPanelProps, a11yProps } from "../Tabs.MUI/Tabs.interface";
import { Box, Typography, Tabs, Tab, Modal, Backdrop } from "@mui/material";
import { Property } from "../../components/move-inRegistrationTabs/PropertyDetailsTab";
import { Output } from "../../components/move-inRegistrationTabs/TenantOwnerDetails";
import Info from "../../components/move-inRegistrationTabs/InfoTab";
import { useEffect, useRef, useState } from "react";
import MoveInOut, { RegistrationData } from "../../stores/MoveInOutStore";
import User from "../../stores/UserStore";
import { observer } from "mobx-react";
import nocsRequestsStore from "../../stores/NocsRequestsStore";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import DialogContentText from "@mui/material/DialogContentText";
import DialogContent from "@mui/material/DialogContent";
import TypeModal from "./TypeModal";
import VerifyAndPay from "../../components/MoveOutTerminationTabs/VerifyAndPay";
import ErrorSubscription from "../../stores/ErrorSubscriptionStore";
import { ToastContainer, toast } from "react-toastify";

// import { Frames, CardNumber, ExpiryDate, Cvv } from 'frames-react';
import CardsPopup from "../../components/MoveOutTerminationTabs/CardsPopup";
import { GatewaySelection } from "../../components/MoveOutTerminationTabs/GatewaySelection";
import CardsStore from "../../stores/CardsStore";
import generalStore from "../../stores/GeneralStore";
import { Link, useLocation, useNavigate } from "react-router-dom";

import Thankyou from "../../components/SocialCaseTbas/Thankyou";
import General from "../../stores/GeneralStore";
import axios from "axios";
import { toJS } from "mobx";
import { style } from "@mui/system";
import CustomErrorToaster from "../../components/ErrorToaster/CustomErrorToaster";
import UserExistModal from "./UserExistModal";
import PendingDuesModal from "./PendingDuesModal";
import PendingOrderModal from "./PendingOrderModal";
import { NotifyError } from '../../utils/ShowError'
import LoginModal from "../LoginModal/LoginModal";
import { NotifySuccess } from "../../utils/ShowSuccess";
import logoutUaePassUrl from "../../utils/logoutUAEUrlConstruct";
import Tick from '../../assets/tick.svg'
import constants from "../../utils/constants";
import { ACTIVE_PAYMENT_GATEWAY } from "../../utils/constants";

interface AppConfig {
  "isCheckout" : boolean
}

//  Tri-state result of the CC&B pending-case check.
//  Only "clear" may proceed - "unknown" must fail closed.
type PendingOrderCheck = "clear" | "blocked" | "unknown";

export function TabPanel(props: TabPanelProps) {
  const { children, value, index, padding, width, background, ...other } =
    props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ width: width, background: background, padding: General?.isLargeScreen ? '' : "0.8rem" }}
    >
      {value === index && (
        <Box sx={{ p: value === 3 ? 0 : 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const TabWithCount = ({ isLargeScreen, children, count, value }: any) => {
  const ColorAss = General?.ColorAss;
  return (
    <Box
      sx={{
        display: "inline-flex",
        justifyContent: "start",
        alignItems: "start",
        flexDirection: "row-reverse",
        width: "16.8vw",
        fontFamily: "Segoe UI",
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "15px",
        lineHeight: "20px",
      }}
    >
      <Typography
        sx={{
          wordBreak: "normal",
          marginRight: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "1rem" : ""
        }}
        component="div">
        {children}
      </Typography>
      {count ? (
        <Typography
          component="div"
          variant="body2"
          sx={{
            marginRight: "0.5rem",
            borderRadius: "50%",
            background: count <= value ? General.contrast.contrastBackground ? General.contrast.contrastBackground : 'rgba(98, 170, 81, 1)' :
              value === count - 1 ? General.contrast.contrastBackground
                ? General.contrast.contrastBackground
                : General?.ColorAss :
                //none active
                General.contrast.contrastColor
                  ? General.contrast.contrastColor : "#fff",
            color: value === count - 1 ? "#fff" : General.contrast.contrastBackground ? General.contrast.contrastBackground : ColorAss,
            height: isLargeScreen ? "1rem" : "2rem",
            width: isLargeScreen ? "1rem" : "2rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0.9rem",
          }}
        >

          {count <= value ? <img src={Tick} alt="" /> : count}
        </Typography>
      ) : null}
    </Box>
  );
};

const MoveInRegistration = () => {
  const location = useLocation();
  const orderIDParam = location?.state?.id;
  const [typeModalOpen, setTypeModalOpen] = useState(false);
  const [otpModalOpen, setOTPModalOpen] = useState(false);
  const [value, setValue] = useState<any>(0);
  const [orderId, setOrderId] = useState<any>();
  const [submit, setSubmit] = useState(false);
  const [owner, setOwner] = useState(false);
  const [openCards, setOpenCards] = useState(false);
  const [openCard, setOpenCard] = useState(true);
  const [userNamePersonId, setUserNamePersonId] = useState();
  const [isUserExist, setIsUserExist] = useState(false);
  const [showPendingOrderDialog, setShowPendingOrderDialog] = useState(false);
  const [submitData, setSubmitData] = useState<RegistrationData | null>(null);
  const [personLargeId, setPersonLargeId] = useState<any>();
  const [moveInType, setType] = useState<any>();
  const [businessType, setBusinessType] = useState<any>();
  const [captchareset, setCaptchareset] = useState(false);
  const sewerageNumberRef = useRef<HTMLInputElement | null>(null);
  const [proceedToShowDetails, setProceedToShowDetails] = useState(false);
  const [isVerificationComplete,setIsVerificationComplete] = useState(false);
  const [openPendingDue, setOpenPendingDue] = useState(false);
  const [isMoveInLoginWithNoDue, setIsMoveInLoginWithNoDue] =
    useState<any>(false);

  const [attempts, setAttempts] = useState(0);
  const [isRecaptchaVerified, setIsRecaptchaVerified] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");
  const [loading, setIsLoading] = useState(false);
  const currentLanguage = localStorage.getItem("settingUplanguage") ?? "en-US"

  const navigate = useNavigate();

  const [config, setConfig] = useState<AppConfig | null>(null);
  
      useEffect(() => {
          async function loadConfig() {
            try {
              const response = await fetch('/config/config.json'); 
              const json = await response.json();
              setConfig(json);
            } catch (err) {
              console.error("Error loading config:", err);
            }
          }
          loadConfig();
        }, []);

const handleGetCardsList = async () => {
  await CardsStore.getCardsList({ errorId: "getCardsListError" });
  };
   useEffect(() => {
    handleGetCardsList();
   },[])

  const handleClickOpenPendingDue = () => {
    setOpenPendingDue(true);
  };
  const handleClosePendingDue = () => {
    setOpenPendingDue(false);
     General?.handleBackClick();
     setValue(0);
     localStorage.removeItem('TabValue')
  };

  const handleCardsModalClose = () => {
    setOpenCards(false);
    General?.handleBackClick();
     setValue(0);
     localStorage.removeItem('TabValue')
  };
  const handleTypeModalOpen = async () => {
    //Mafroud y koun fi request
    setTypeModalOpen(true);
  };

  const handleTypeModalClose = () => setTypeModalOpen(false);
  const handleOtpModalClose = () => setOTPModalOpen(false);
  const isCheckoutActive = ACTIVE_PAYMENT_GATEWAY === 'CHECKOUT';
  //  Checking pending orders

  const handlegetPersonUsername = async (personID: any) => {
    const res = await General.getPersonUsername(personID);
    if (res) {
      setIsUserExist(true);
    }
    return res;
  }

  const notify = (message: any) =>
    toast.error(<CustomErrorToaster errorMessage={message} />);

  //  For I'm the owner

  const checkOwner = async () => {
    try {
      setOwnerLoader(true);
      setOwner(true);
      setHeaderState("registration_owner");
      const redireactFrom = localStorage.getItem("redirectFrom");
      if (redireactFrom == "uaePassLogin") {
        handleUaePassRegistaration("owner");
        return;
      }
      await handlegetPersonUsername(General?.premise?.ownerAccount?.personID);
      if (General?.premise?.ownerAccount) {
        if (!General.premise.ownerAccount.email && !General.premise.ownerAccount.phoneNumber) {
          NotifyError(General?.codeLabels['cm_err_email_mob']?.label ? General?.codeLabels['cm_err_email_mob']?.label : "Cannot proceed registration without mobile number and email");
          setOwnerLoader(false);
          return;
        }
      }
      // }
      const ownerCheckOrder = await checkPendingOrder();
      if (ownerCheckOrder === "blocked") {
        setShowPendingOrderDialog(true);
        setOwnerLoader(false);
        return;
      }
      if (ownerCheckOrder === "unknown") {
        notifyPendingOrderCheckFailed();
        setOwnerLoader(false);
        return;
      }
      if (!User?.profile?.personId) {
        //logged out

        //make sure enno username fade mish min wara bajjit api (handle error)
        if (General.premise.username) {
          ErrorSubscription.subscribe({
            message: `Person Id has an existing username ${General.premise.username}`,
            id: "propertySewerageError",
          });
          setOwnerLoader(false);
          return;
        } else {
          //check owner details (setvalue(1))
          setValue(1);
          localStorage.setItem('TabValue', '1')
        }
        setOwnerLoader(false);
      }
    } catch (error) {
      setOwnerLoader(false);
      NotifyError(General?.codeLabels['cm_servererror']?.label)
    }
  };

  //  Checking pending orders againt user
  //  Fails closed: only an explicit "S" is clear. A "F" status, an empty body, or a
  //  rejection ErrorWrapper swallowed (leaving res undefined) all come back "unknown".
  const checkPendingOrder = async (): Promise<PendingOrderCheck> => {
    const res = await MoveInOut.checkMoveInOrderExist({
      errorId: "validateUseName",
      data: {
        premiseId: General.premise.premiseId,
      },
    });
    const status = res?.result?.status;
    if (status === "S") return "clear";
    if (status === "N") return "blocked";
    return "unknown";
  };

  //  "unknown" means the CC&B case check could not complete - ask the user to retry.
  const notifyPendingOrderCheckFailed = () =>
    NotifyError(
      General?.codeLabels["cm_ccb_case_validation_failed"]?.label
        ? "cm_ccb_case_validation_failed"
        : "cm_servererror"
    );

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    // localStorage.setItem('TabValue',newValue.toString())
    // General?.handleBackClick();

  };

  const handleSubmit = (e?: any) => {
    setSubmit(true);
  };

  const [fileData, setFiledata] = useState<any>()
  const handleSubmitDoc = async (fileData: any) => {
    console.log('kk', fileData);
    // setFiledata(fileData)
    const data = {
      ...fileData,
      orderId: null,
      action: 1,
    }

    await User?.uploadDocuments({ errorId: "uploaddocument", data })
  };


  //  for Submit & Register
  const [newEmailId, setNewEmailId] = useState<any>()
  const [newMobileNum, setNewMobileNum] = useState<any>()
  const [resendOtp, setResendotp] = useState(false)

  //////////new flow///////////////////////////////////////
  const [register, setRegister] = useState(false);
  const [tenantLoader, setTenantLoader] = useState(false);
  const [ownerLoader, setOwnerLoader] = useState(false);
  const [headerState, setHeaderState] = useState("moveInReg_tenant");
  const [validateLoader, setValidateLoader] = useState(false);
  const [registerLoader, setRegisterLoader] = useState(false);
  const [messageTitle, setTitle] = useState<any>();
  const handleMoveInRegister = async (data: any, files: any, sendOtp: Boolean) => {
    console.log(files?.files)
    try {
      
      const { email, mobileNumber } = data;
      setNewEmailId(email); //to send otp to form daata
      setNewMobileNum(mobileNumber)
      setSubmitData(data);
      setFiledata(files?.files)
      if (sendOtp) {
        setOTPModalOpen(true)
      } else {
        setRegisterLoader(true);
        if (General?.premise?.ownerAccount && General?.premise?.tenantAccount == null) {
          if (owner) {
            submitRegisterLogedOutOwner(data, files?.files)
          } else {
            moveInAndRegister(data, files?.files);
          }
        } else if (General?.premise?.ownerAccount && General?.premise?.tenantAccount) {
          submitRegisterLogedOutOwner(data, files?.files);
        } else {
          NotifyError(General.codeLabels['cm_noowner']?.label ? General.codeLabels['cm_noowner']?.label : "No owner associated for the Sewerage number. Please contact our Customer Service for assistance.")
          setRegisterLoader(false);
        }
      }
    } catch (error) {
      setRegisterLoader(false);
    }
  };

  const checkIsPerformingMoveinWithRegistration = () => {
    if (User.info.reasonCode == 15) {
      if (owner) {
        if (General?.premise?.ownerAccount == null) {
          return true;
        }
      } else {
        if (General?.premise?.tenantAccount == null) {
          return true;
        }
      }
    }
    return false
  }
  const fetchPersonId = () => {
    if (owner) {
      if (General?.premise?.ownerAccount != null) {
        return General?.premise?.ownerAccount?.personID;
      }
    } else {
      if (General?.premise?.tenantAccount != null) {
        return General?.premise?.tenantAccount?.personID;
      }
    }
  };
  const handleMoveInRegisterWithUaePass = async (data: any, files: any, sendOtp: Boolean) => {
   
    const { email, mobileNumber } = data;
    console.log("handleMoveInRegisterWithUaePass : ", data)
    setNewEmailId(email); //to send otp to form daata
    setNewMobileNum(mobileNumber)
    setSubmitData(data);
    setFiledata(files?.files)
    if (sendOtp) { //if user edit/update mobile number
      setOTPModalOpen(true)
      // setRegisterLoader(false);
    } else {
      setRegisterLoader(true);
      if (User.info.reasonCode == 15) {
        if (checkIsPerformingMoveinWithRegistration()) {
          moveInAndRegister(data, files?.files);
        } else {
          submitRegisterLogedOutOwner(data, files?.files)
        }
      } else {
        if (fetchPersonId()) {
          submitRegisterLogedOutOwner(data, files?.files);
        } else {
          moveInAndRegister(data, files?.files);
        }
      }
    }
  };
  const [disabledBtn, setDisabled] = useState<any>(false);
  const handleGetDetails = async () => {
    setDisabled(false);

    localStorage.removeItem("otpData");
    localStorage.removeItem("type");
    localStorage.removeItem("largeId");
    localStorage.removeItem("businessType");
    ErrorSubscription.unSubscribeAll();
    General?.handleBackClick() //remoce errors obj
    MoveInOut?.clearCache() //remoce errors obj
    User?.clearCache() //remoce errors obj
    // setIsMoveInLoginWithNoDue(false);today
    try {
      if (sewerageNumberRef.current && sewerageNumberRef.current?.value) {
        setIsLoading(true);
        const dataWithError = {
          data: {
            premiseId: sewerageNumberRef.current!.value,
            recaptchaToken: captchaToken,
            platform: "Web"
          },
          errorId: "propertySewerageError",
        };

        if (!isRecaptchaVerified) {
          // Disable the button after three attempts if reCAPTCHA is not verified
          setIsLoading(false); // Stop loading
          return;
        }
        setAttempts(attempts + 1);
        var getPremiseRes;
        if (User?.profile?.personId) {
          getPremiseRes = await General.handlePremiseDetails(dataWithError);
        } else {
          getPremiseRes = await General.handlePremiseDetailsNoToken(dataWithError);
        }
        if (General?.premise) {
          if (!getPremiseRes.ownerAccount?.personID) {
            NotifyError(General?.codeLabels['cm_noowner']?.label);
            setRegisterLoader(false);
          }
          const {
            ownerAccount,
            tenantAccount,
            isConnected,
            isVacant,
            networkType,
          } = getPremiseRes || {};
          const userPersonId = User?.profile?.personId;

          const showError = (labelKey: any) => {
            NotifyError(
              General?.codeLabels[labelKey]?.label?.replace(
                "{0}",
                sewerageNumberRef.current?.value
              )
            );
            setProceedToShowDetails(false);
            setIsLoading(false);
          };
          if (!userPersonId) {
            // Only network check for new user
              if (networkType !== "INSIDE") {
                 showError("cm_prem_not_within_network");
                 setProceedToShowDetails(false);
               } else {
               setProceedToShowDetails(true);
                setIsLoading(false);
               }
             setRegisterLoader(false);
              setIsLoading(false);
            
          }
          else{
            
           if (networkType !== "INSIDE") {
            showError("cm_prem_not_within_network");
            setProceedToShowDetails(false);
          } else if (isConnected !== "Y") {
            showError("cm_prem_not_connected");
          } 
          // else if (isVacant !== "Y") {
          //   showError("cm_prem_not_vacant");
          // }
          else {
            // All validations passed
            setProceedToShowDetails(true);
            setIsLoading(false);
          }
          }

        
          setRegisterLoader(false);
          setIsLoading(false);
        }
        if (General?.premise?.tenantAccount == null && General?.premise?.ownerAccount == null) {
          setDisabled(true);
        }
        if(!General?.premise){
          setCaptchareset(true);
        }

      }
    } catch (error) {
        setCaptchareset(true);     
         setIsLoading(false);
    }

  };
  const [loginModal, setLoginModal] = useState(false);
  const handleCheckRegistrationStatus = async (personId: any, type: string, uaeUserData: any) => {
    const data = {
      personId,
    }
    const res = await General?.getRegistarationStatus({ errorId: "getRegistrationStatus", data });
    if (res?.statusCode == 200) {
      if (res?.result?.registationStatus == 21) {
        // General?.initializeDataforUaePass(uaeUserData);
        // setValue(2)
        // localStorage.setItem('TabValue','2')
        setOTPModalOpen(true);

        // handleUaePassRegistaration(type);
      } else if (res?.result?.registationStatus == 22 || res?.result?.registationStatus == 23) {
        setLoginModal(true);
        localStorage.removeItem("reasonCode")
        localStorage.removeItem("redirectFrom")
      }
      else if (res?.result?.registationStatus == 6504) {
        NotifyError(res?.result?.message);
        setRegisterLoader(false);
        navigate('/')
      }
    } else {
      localStorage.removeItem('redirectFrom')
      localStorage.removeItem('reasonCode')
    }
  }
  async function waitUntilVerified( interval = 500) {
  while (!isVerificationComplete) {
    await new Promise(resolve => setTimeout(resolve, interval));
  }
}
  const handleUaePassRegistaration = async (type: string,) => {
    try {
      const uaePassCheckOrder = await checkPendingOrder();
      if (uaePassCheckOrder !== "clear") {
        if (uaePassCheckOrder === "blocked") {
          setShowPendingOrderDialog(true);
        } else {
          notifyPendingOrderCheckFailed();
        }
        setTenantLoader(false);
        setOwnerLoader(false);
        setRegisterLoader(false);
        return;
      }
      var uaeUserData = {
        arName: User.uaePassDetails?.fullnameAR,
        name: User.uaePassDetails?.fullnameEN,
        email: User.uaePassDetails?.email,
        morning: false,
        evening: false,
        afternoon: false,
        state: null,
        dateOfBirt: null,
        favouriteServiceDeliveryChannel: null,
        language: null,
        mobileNumber: User.uaePassDetails?.mobile,
        nationality: {
          key: User.uaePassDetails?.nationalityEN,
          value: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? constants.countriesAr.filter((nationality) => nationality.key == User.uaePassDetails?.nationalityEN)[0]?.value : General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "HIN" ? constants.countriesHi.filter((nationality) => nationality.key == User.uaePassDetails?.nationalityEN)[0]?.value : constants.countriesEn.filter((nationality) => nationality.key == User.uaePassDetails?.nationalityEN)[0]?.value,
        },
        city: null,
        favouritePaymentChannel: null,
        alternateEmail: null,
        gender: {
          value: User.uaePassDetails?.gender,
          key: User.uaePassDetails?.gender == 'Male' ? "M" : "F",
        },
        contractDate: null
      }
      if (User.info.reasonCode == "5") { ///Mean user it;s login with uae pass he is trying to register with an EID

        General?.initializeDataforUaePass(uaeUserData);
        if (type == "tenant" && General?.premise?.tenantAccount == null) {
          localStorage.setItem("tenantNullWithEID", "true");
           await handlegetDues();
           if (!owner && MoveInOut.paymentDetails.totalAmount > 0) {
            setOpenPendingDue(true);
            setTenantLoader(false);
          } else {
            setValue(2);
            localStorage.setItem('TabValue', '2')
          }
          // setValue(2);
          // localStorage.setItem('TabValue', '2')
        } else {
          setOTPModalOpen(true);
          // await waitUntilVerified();
          // const data = {
          //   personId: type == "owner" ? General?.premise?.ownerAccount ? General?.premise?.ownerAccount?.personID : MoveInOut?.userValidatedDetails?.personId : General?.premise?.tenantAccount ? General?.premise?.tenantAccount.personID : MoveInOut?.userValidatedDetails?.personId,
          //   uaepassFlag: true,
          //   sewerageId: sewerageNumberRef.current!.value
          // }
          // try {
          //   const res = await General?.getRegistarationDetails({ errorId: "getRegistrationDetails", data });
          //   if (res?.statusCode == 200) {
          //     setValue(2);
          //     localStorage.setItem('TabValue', '2')
          //   }
          //   if (res?.statusCode != 200) {
          //     NotifyError(General?.codeLabels?.[res]?.label)
          //     setOwnerLoader(false)
          //     setTenantLoader(false)
          //   }
          // } catch (error) {
          //   setOwnerLoader(false)
          //   setTenantLoader(false)
          // }

        }
      } else {
        if (type == "tenant") {
          if (General.premise.tenantAccount == null) {
            General?.initializeDataforUaePass(uaeUserData);
             await handlegetDues();
            if (!owner && MoveInOut.paymentDetails.totalAmount > 0) {
            setOpenPendingDue(true);
            setTenantLoader(false);
          } else {
            setValue(2);
            localStorage.setItem('TabValue', '2')
          }
            // setValue(2)
            // localStorage.setItem('TabValue', '2')
          } else {
            handleCheckRegistrationStatus(General?.premise?.tenantAccount?.personID, "tenant", uaeUserData)
          }
        }
        else {
          if (General.premise.ownerAccount == null) {
            General?.initializeDataforUaePass(uaeUserData);
            setValue(2)
            localStorage.setItem('TabValue', '2')
          } else {
            handleCheckRegistrationStatus(General?.premise?.ownerAccount?.personID, "owner", uaeUserData)
          }
        }
      }
    } catch (error) {
      setTenantLoader(false);
      setOwnerLoader(false);
    }
    // const reasonCode=User.info.reasonCode;

  }
  const checkTenant = async () => {
    if(General?.premise?.tenantAccount ){
      if(!General?.premise?.tenantAccount?.email && !General?.premise?.tenantAccount?.phoneNumber){
        NotifyError(General?.codeLabels['cm_err_email_mob']?.label ? General?.codeLabels['cm_err_email_mob']?.label : "Cannot proceed registration without mobile number and email");
        setTenantLoader(false);
        return;
      }
    }
    try {
      setTenantLoader(true);
      setOwner(false);
      const redireactFrom = localStorage.getItem("redirectFrom");
      if (redireactFrom == "uaePassLogin") {
        handleUaePassRegistaration("tenant")
        return;
      }
      if (General?.premise?.tenantAccount) {
        setHeaderState('registration_tenant')
        const res = await handlegetPersonUsername(General?.premise?.tenantAccount?.personID)
        if (res?.status == "Success") {
          return;
        }
      }



      const checkOrder = await checkPendingOrder();
      if (checkOrder === "blocked") {
        setShowPendingOrderDialog(true);
        setTenantLoader(false);
        return;
      }
      if (checkOrder === "unknown") {
        notifyPendingOrderCheckFailed();
        setTenantLoader(false);
        return;
      }


      if (General.premise.tenantAccount) {
        // ErrorSubscription.subscribe({
        //   message: "Premise already has a tenant",
        //   id: "propertySewerageError",
        // });
        if (User?.profile?.personId) { ///for logged in only
          NotifyError(General?.codeLabels['cm_tenanterr']?.label)
          setValue(0)
        } else {
          setValue(1)
        }

        localStorage.setItem('TabValue', '0')
        setTenantLoader(false);
        return;
      }
      if (User?.profile?.personId) {
        // has to do yet
        //logged in
        await handlegetDues();
        if (MoveInOut.paymentDetails.totalAmount > 0) {
          setValue(2);
        } else {
          setValue(1);
          localStorage.setItem('TabValue', '1')
        }

        // setValue(1);
      } else {
        //logged out

        handleTypeModalOpen(); // fi payment check
      }
      setTenantLoader(false);
    } catch (error) {
      NotifyError(General?.codeLabels['cm_servererror']?.label)
      setTenantLoader(false);
    }

  };
  const onClickTypeValidate = async (
    id: string | number,
    type: string | number,
    businessType: string | undefined
  ) => {

    setValidateLoader(true);
    setPersonLargeId(id);
    setType(type);
    if (businessType !== undefined) {
      setBusinessType(businessType);
    } else {
      setBusinessType(""); // or provide a default value if needed
    }
    if (type == 'B') {
      var user = {}
      if (businessType == "FZ" || businessType == "MFZ") {
        user = {
          arName: General?.fzUser?.accountDetails?.fZ_Company_Name_Arabic__c,
          name: General?.fzUser?.accountDetails?.name,
          email: General?.fzUser?.accountDetails?.fZ_Email__c,
          morning: false,
          evening: false,
          afternoon: false,
          state: "",
          dateOfBirth: "",
          favouriteServiceDeliveryChannel: {
            key: "",
            value: "",
          },
          language: {
            key: "",
            value: "",
          },
          mobileNumber: General?.ajmanUser?.mobileNumber,
          nationality: {
            key: "",
            value: "",
          },
          city: "",
          favouritePaymentChannel: {
            key: "",
            value: "",
          },
          alternateEmail: "",
          gender: {
            key: "",
            value: "",
          },
          contractDate: "",
        };
      } else {
        user = {
          arName: General?.ajmanUser?.tradeNameAR,
          name: General?.ajmanUser?.tradeNameEN,
          email: General?.ajmanUser?.emailAddress,
          morning: false,
          evening: false,
          afternoon: false,
          state: "",
          dateOfBirth: "",
          favouriteServiceDeliveryChannel: {
            key: "",
            value: "",
          },
          language: {
            key: "",
            value: "",
          },
          mobileNumber: '',
          nationality: {
            key: "",
            value: "",
          },
          city: "",
          favouritePaymentChannel: {
            key: "",
            value: "",
          },
          alternateEmail: "",
          gender: {
            key: "",
            value: "",
          },
          contractDate: "",
        };
      }

      General?.initializeUserOtpData(user, General?.premise)
    }
    try {
      const dataWithError = {
        data: { id },
        errorId: "emirateId",
      };
      let emirateId;
      if(type == 'I'){
         emirateId = await General.validateEmirateId(dataWithError);

      }
      if (emirateId?.result || type == "B") {
        try {
          const res = await MoveInOut.getMoveInDetails({
            id,
            type : businessType ? businessType : type,
            premiseId: General.premise.premiseId,
          });
        } catch (error: any) {
          setValidateLoader(false)
          handleTypeModalClose();
          console.log(error)
          NotifyError(General?.codeLabels[error.response.data.error[0].message]?.label ? General?.codeLabels[error.response.data.error[0].message]?.label : "Number has multiple users. Please contact our Customer Service for assistance.")
          return;
        }

        // Access 'message' property from 'data'
        if (Object.keys(MoveInOut.userValidatedDetails).length) {
          // checkPaymentDue();today
          setOTPModalOpen(true)
          handleTypeModalClose();
          setValidateLoader(false)
        } else {
          handleTypeModalClose();
          setValidateLoader(false)
          if (!owner) await handlegetDues();
          if (!owner && MoveInOut.paymentDetails.totalAmount > 0) {
            setOpenPendingDue(true);
          } else {
            setValue(2);
            localStorage.setItem('TabValue', '2')
          }
           setValue(2);
            localStorage.setItem('TabValue', '2')
        }
      }

    } catch (error: any) {
      const message = error.response.data.error[0].message;
      if (error.response.data.error[0].message === "cm_useralreadyregistered") {
        notify("User already registered");
        setValidateLoader(false)
      }
    }
  };
  const cleanCache = () => {
    setSubmitData(null);
    localStorage.removeItem("otpData");
    localStorage.removeItem('redirectFrom')
    localStorage.removeItem('reasonCode')
    setRegisterLoader(false);
    localStorage.removeItem('TabValue')
    localStorage.removeItem('isOwner')
    localStorage.removeItem('premise')
  }
  console.log(toJS(User?.ownerMovein))
  const submitRegisterLogedOutOwner = async (data: any, files: any) => {
    const fromUaePass = localStorage.getItem('redirectFrom');
    try {
       await User.register({ errorId: "registerMoveInError", data });
      if (fromUaePass == 'uaePassLogin') {
        if (User?.ownerMovein?.message !=null) {
          if (files?.length > 0) {
            const data = {
              key:User?.ownerMovein?.key,
              files: files,
              orderId: User?.ownerMovein?.orderId,
              action: User?.ownerMovein?.action,
              UploadType:fromUaePass == 'uaePassLogin' ? "" :  "AjmanKnowsYou",
              UploadScreen: User?.info?.personId ? 'mwl' : 'mwol'
            }

            await User?.uploadDocuments({ errorId: "uploaddocument", data })
          }
          setOTPModalOpen(false);
          NotifySuccess(General?.codeLabels?.['cm_ms_dtls_sent']?.label?General?.codeLabels?.['cm_ms_dtls_sent']?.label:"Your Registration details has been sent to Ajman sewerage for verification. Once verified you will receive an email and you can login using the 'Login with UAE pass button'.")
          cleanCache()
        navigate('/')
        } 
        else {
          if (files?.length > 0) {
            const data = {
              key:User?.ownerMovein?.key,
              files: files,
              orderId: User?.ownerMovein?.orderId,
              action: User?.ownerMovein?.action,
              UploadType:fromUaePass == 'uaePassLogin' ? "" :   "AjmanKnowsYou",
              UploadScreen: User?.info?.personId ? 'mwl' : 'mwol'
            }

            await User?.uploadDocuments({ errorId: "uploaddocument", data })
          }
          let data = {
            uuid: User.uaePassDetails.uuid ? User.uaePassDetails.uuid : null,
            emiratesId: User.uaePassDetails.emiratesId
              ? User.uaePassDetails.emiratesId
              : null,
            uaepassenabled: true,
          };
          await User.loginUaePass({
            data,
            errorId: "loginError",
          });
          if (User.info.status == true && User?.info?.token) {
            window.localStorage.setItem("user", JSON.stringify(User?.info));
            window.localStorage.setItem("us_tkn", User?.info?.token);
            window.localStorage.setItem("username", User?.info?.userName);
            User.getProfile(User.info.personId as string);
            User.getFavourites();
            localStorage.setItem('isUaePass', 'true')
            setOTPModalOpen(false);
            navigate("/dashboard");
          }
          cleanCache()
        }
      } else {
        if (User?.ownerMovein?.message == "cm_registersuccess") {
          // setOrderId(res?.result?.orderId);
          setOTPModalOpen(false);
          setRegister(true);
          const title = General?.codeLabels[User?.ownerMovein?.message]?.label;
          setTitle(title);
          setValue(3);
          setSubmitData(null);
          cleanCache()
          if (files?.length > 0) {
            const data = {
              key:User?.ownerMovein?.key,
              files: files,
              orderId: User?.ownerMovein?.orderId,
              action: User?.ownerMovein?.action,
              UploadType:fromUaePass == 'uaePassLogin' ? "" :   "AjmanKnowsYou",
              UploadScreen: User?.info?.personId ? 'mwl' : 'mwol'
            }

            await User?.uploadDocuments({ errorId: "uploaddocument", data })
          }

        } else {
          cleanCache()
          navigate('/')
        }
      }
    } catch (error) {
      setOTPModalOpen(false);
      setRegisterLoader(false);
      cleanCache()
      if (fromUaePass) {
        await User?.uaeGetConfig();
        navigate('/')
      } else {
        navigate('/')
      }

    }


  };
  const moveInAndRegister = async (data: any, files: any) => {
    const fromUaePass = localStorage.getItem('redirectFrom');
    try {
      console.log("moveInAndRegister : ", data)
      const payload = {
        data : {
             ...data,
            UploadType: fromUaePass === 'uaePassLogin' ? '' : 'AjmanKnowsYou',
            UploadScreen: User?.info?.personId ? 'mwl' : 'mwol',
            },
        multiFileUpload: files,
        isFileTypeValid: true,
        isFileUploadValid: true,

      }
      const res = await MoveInOut.registerMoveIn({
        errorId: "registerMoveInError",
        data: payload,
      });

      //TODO check if reponse right

      if (fromUaePass == 'uaePassLogin') {
        if (MoveInOut.moveInRegistrationResponse.message == "cm_ms_dtls_sent") {
          if (files?.length > 0) {
            const data = {
              key:MoveInOut?.moveInRegistrationResponse?.key,
              files: files,
              orderId: MoveInOut?.moveInRegistrationResponse?.orderId,
              action: MoveInOut?.moveInRegistrationResponse?.action,
              UploadType: fromUaePass == 'uaePassLogin' ? "" :  "AjmanKnowsYou",
              UploadScreen: User?.info?.personId ? 'mwl' : 'mwol'
            }
            // await User?.uploadDocuments({ errorId: "uploaddocument", data })
          }
          setOTPModalOpen(false);
          NotifySuccess(General?.codeLabels?.['cm_ms_dtls_sent']?.label ? General?.codeLabels?.['cm_ms_dtls_sent']?.label : "Your Registration details has been sent to Ajman sewerage for verification. Once verified you will receive an email and you can login using the 'Login with UAE pass button'.")
          navigate('/')
          cleanCache()
        }
      } else {
        if (MoveInOut.moveInRegistrationResponse.message == "cm_mob_regsuccmsg") {
          if (files.length > 0) {
            const data = {
              key:MoveInOut?.moveInRegistrationResponse?.key,
              files: files,
              orderId: MoveInOut.moveInRegistrationResponse?.orderId,
              action: MoveInOut.moveInRegistrationResponse?.action,
              UploadType: fromUaePass == 'uaePassLogin' ? "" :  "AjmanKnowsYou",
              UploadScreen: User?.info?.personId ? 'mwl' : 'mwol'
            }
            // await User?.uploadDocuments({ errorId: "uploaddocument", data })
          }
          console.log(res);
          setOTPModalOpen(false);
          const msg = General?.codeLabels[MoveInOut.moveInRegistrationResponse.message]?.label;
          const titlt = msg?.replace("Reference number :", "")?.replace('{0}', '')?.replace(': الرقم المرجعى:')
          setTitle(titlt);
          setOrderId(MoveInOut.moveInRegistrationResponse?.orderId);
          setValue(3);
          cleanCache()


          setRegisterLoader(false);
        } else {
          NotifyError(General?.codeLabels?.['cm_something_went_wrong']?.label?General?.codeLabels?.['cm_something_went_wrong']?.label:"Something went wrong. Please contact our Customer Service for assistance.");
          setOTPModalOpen(false);
          cleanCache()
          navigate('/')
        }
      }
    } catch (error) {
      setOTPModalOpen(false);
      setRegisterLoader(false);
      cleanCache()
      if (fromUaePass) {
        await User?.uaeGetConfig();
        navigate('/')
      } else {
        navigate('/')
      }
    }
  }
  const moveInForLogInUser = async (file: any) => {
    const data={
      premiseId: General?.premise?.premiseId,
      vatNo: null,
      platform: "web",
      customerMessage:file?.customerMessage,
      action:1,
      uploadType: "AjmanKnowsYou",
      uploadScreen: User?.info?.personId ? 'mwl' : 'mwol'

    }
    const payload={
      data,
      multiFileUpload:file?.files,
      isFileTypeValid: true,
      isFileUploadValid: true,
    }
    try {
      await MoveInOut.moveIn({
        errorId: "moveInError",
        data: payload,
      });
      if (
        MoveInOut.moveInResponse.message == "cm_mob_moveincom" ||
        MoveInOut.moveInResponse.action
      ) {
        setSaveLoader(false);
        setOrderId(MoveInOut?.moveInResponse.caseId);
        const msg = General?.codeLabels[MoveInOut.moveInResponse.message]?.label;
        const titlt = msg?.replace("Reference number :", "")?.replace('{0}', '')?.replace(': الرقم المرجعى:')
        setTitle(titlt);
        setValue(3);
        if (file) {
          const data = {
            ...file,
            key:MoveInOut?.moveInResponse?.key,
            orderId: MoveInOut?.moveInResponse.orderId,
            action: MoveInOut?.moveInResponse.action,
            UploadType: "AjmanKnowsYou",
            UploadScreen: User?.info?.personId ? 'mwl' : 'mwol'
          }
          // await User?.uploadDocuments({ errorId: "uploaddocument", data })
        }
      }
      localStorage.removeItem("premise");
      localStorage.removeItem("MoveInPayment");
    } catch (error) {
      setSaveLoader(false)
    }

  };
  const handlegetDues = async () => {
    await MoveInOut.getMoveInDue({
      errorId: "getMoveInDueError",
      data: {
        premiseId: General?.premise?.premiseId,
        personID: User?.profile?.personId ? User?.profile?.personId : owner
          ? General.premise.ownerAccount?.personID
          : General.premise.tenantAccount ? General.premise.tenantAccount?.personID : MoveInOut?.userValidatedDetails?.personId as string,
      },
    });
  }
  const [paymentLoader, setPaymentLoader] = useState(false);
  const handleMoveInPayment = async ({
    token,
    cvv,
    type,
    paymentRequestType,
    email,
  }: {
    token: string;
    cvv?: string;
    email?: string;
    type?: string;
    paymentRequestType?: number;
  }) => {
    setPaymentLoader(true);
    const transactionId = MoveInOut.paymentDetails.transactionId;
    const amount = MoveInOut.paymentDetails.totalAmount;
    const accounts = MoveInOut.paymentDetails.accounts;
    const personId = User?.profile?.personId ? User?.profile?.personId : owner
      ? General.premise.ownerAccount?.personID
      : General.premise.tenantAccount ? General.premise.tenantAccount?.personID : MoveInOut?.userValidatedDetails?.personId as string

    if (!User?.profile?.personId) await General.getToken();

    let responseee = await MoveInOut.moveInPayment({
      errorId: "moveInPaymentError",
      data: {
        accounts,
        amount,
        cvv,
        paymentRequestType,
        personId,
        token,
        transactionId,
        type,
        email: MoveInOut?.email,
      },
    });


    if (responseee?.message == "Success") {
      if (User?.info?.personId) {
        localStorage.setItem('premiseData', JSON.stringify(General?.premise))
      } else {
        localStorage.setItem('otpData', JSON.stringify(General?.otpUserData));
        localStorage.setItem('premiseData', JSON.stringify(General?.premise))
        localStorage.setItem('businessType', businessType?.toString())
        localStorage.setItem('largeId', personLargeId?.toString())
        localStorage.setItem('type', moveInType?.toString())
        localStorage.setItem('isOwner', owner ? "true" : "false");

      }
      localStorage.setItem('MoveInPayment', "true");
      setPaymentLoader(false)
      // handleCardsModalClose();
       setOpenCards(false);

      window.open(responseee?.result?.redirectUrl, "_self");
    }
  };

  const setValueToMoveInInfo = async (transactionId: string) => {
    const fromUaePass = localStorage.getItem('redirectFrom');
    
    if (submitData == null) {
      setOTPModalOpen(false);
      if (fromUaePass == 'uaePassLogin') {
        setValue(2);
        localStorage.setItem('TabValue', '2')
        return;
      }
      // setValue(2);
      // localStorage.setItem('TabValue', '2')
      if (!owner) await handlegetDues();
      if (!owner && MoveInOut.paymentDetails.totalAmount > 0 && !General?.premise?.tenantAccount?.personID) {
        setOpenPendingDue(true);
      } else {
        setValue(2);
        localStorage.setItem('TabValue', '2')
      }
    } else {
      setRegisterLoader(true);
      if (fromUaePass == 'uaePassLogin') {
        if (User.info.reasonCode == 15) {
          if (checkIsPerformingMoveinWithRegistration()) {
            moveInAndRegister({...submitData, transactionId: transactionId}, fileData);
          } else {
            submitRegisterLogedOutOwner({...submitData, transactionId: transactionId}, fileData)
          }
        } else {
          if (fetchPersonId()) {
            submitRegisterLogedOutOwner({...submitData, transactionId: transactionId}, fileData);
          } else {
            moveInAndRegister({...submitData, transactionId: transactionId}, fileData);
          }
        }
      }
      else {//normal registration
        if (General?.premise?.ownerAccount && General?.premise?.tenantAccount == null) {
          if (owner) {
            submitRegisterLogedOutOwner(submitData, fileData)
          } else {
            moveInAndRegister({...submitData, transactionId: transactionId}, fileData);
          }
        } else if (General?.premise?.ownerAccount && General?.premise?.tenantAccount) {
          submitRegisterLogedOutOwner(submitData, fileData);
        } else {
          NotifyError(General.codeLabels['cm_noowner']?.label ? General.codeLabels['cm_noowner']?.label : "No owner associated for the Sewerage number. Please contact our Customer Service for assistance.")
          setRegisterLoader(false);
        }
      }

    }
  };
  const [saveloader, setSaveLoader] = useState(false);
  const ownerContine = async (data: any) => {
    const redireactFrom = localStorage.getItem("redirectFrom")
    if (redireactFrom == "uaePassLogin") {
      setValue(2);
      localStorage.setItem('TabValue', '2')
    }
    else if (User?.info?.personId) {//login
      setSaveLoader(true);
      await moveInForLogInUser(data);
    } else {//logout
      if (General?.premise?.ownerAccount) {
        setOTPModalOpen(true);
      } else {
        setValue(2);
        localStorage.setItem('TabValue', '2')
      }
    }
  };



  const paymentDataForGateway = {
    platform: "web",
    accounts: MoveInOut.paymentDetails.accounts,
    amount: MoveInOut.paymentDetails.totalAmount,
    paymentRequestType: 1,
    personId: User?.profile?.personId || MoveInOut?.userValidatedDetails?.personId,
    transactionId: MoveInOut.paymentDetails.transactionId,
    type: "moveIn",
    returnUrl: `${window.location.origin}/Payment/ExternalRedirect`,
    premiseId: General?.premise?.premiseId,
  }
const handlePaymentInitiation = async (payload: any, gatewayType: string) => {
    if(gatewayType === 'ni'){
 const res = await MoveInOut.NImoveInPayment(payload);

    if (res?.message === "Success") {
      return res; 
    } else {
      throw new Error(res?.message || "Payment failed. Please try again");
    }
    }
    if(gatewayType === 'tabby'){
       if (!User?.profile?.personId){
      let eligibledata = {amount:payload.amount} as any  
           
            eligibledata = {
              ...eligibledata,
              mobile : payload.mobile,
              email : payload.email,
            }
          const eligibilityResponse = await MoveInOut.makeTabbyEligibilityCheck({
            errorId: "tabbyEligibilityCheckError",
            data: eligibledata,
        });
        if (!eligibilityResponse?.result?.isEligible) {
            throw new Error(eligibilityResponse?.result?.message || "Tabby payment is currently not eligible.");
        }}
      const res = await MoveInOut.TabbymoveInPayment(payload);

    if (res?.message === "Success") {
      return res; 
    } else {
      throw new Error(res?.message || "Payment failed. Please try again");
    }
    }
    if(gatewayType === 'tamara'){    
    const res = await MoveInOut.TamaramoveInPayment(payload);

    if (res?.message === "Success") {
      return res; 
    } else {
      throw new Error(res?.message || "Payment failed. Please try again");
    }
  }
}

const checkTabbyEligibility = async (payload: any) => {
  try {
    const response = await MoveInOut.makeTabbyEligibilityCheck({
            errorId: "tabbyEligibilityCheckError",
            data: payload,
          });
    // return !!response?.result?.isEligible;
    const isEligible = !!response?.result?.isEligible;
    const message = response?.result?.message || "";
const isAmountEligible = response?.result?.isAmountEligible;
    return { isEligible, message, isAmountEligible };
  } catch (error) {
    console.error("Eligibility check failed:", error);
    return false;
  }
};

const checkTamaraEligibility = async (payload: any) => {
  try {
    const response = await nocsRequestsStore.makeTamaraEligibilityCheck({
            errorId: "tamaraEligibilityCheckError",
            data: payload,
          });
    const message = response?.result?.message || "";
const isAmountEligible = response?.result?.isAmountEligible;

    return {message, isAmountEligible };
  } catch (error) {
    console.error("Tamara eligibility check failed:", error);
    return false;
  }
};



  useEffect(() => {
    //generalStore.incrementServiceUsage("4");
  }, []);

  useEffect(() => {
    ErrorSubscription.unSubscribeAll();
  }, [General.premise]);

  useEffect(() => {
    const tabValue = localStorage.getItem('TabValue')
    if (tabValue) {
      setValue(Number(tabValue))
    }
    return () => {
      localStorage.removeItem('TabValue')
      // User?.clearCache() 
      // MoveInOut?.clearCache()
      // General?.handleBackClick()
    };
  }, [])
  useEffect(()=>{
        General?.handleBackClick();
        setValue(0);
        localStorage.removeItem('TabValue')
  },[currentLanguage])

const handleBackClick = async()=>{
  const isUaePass=localStorage.getItem('isUaePass');
  if(isUaePass || User.info.reasonCode == 15 || User.info.reasonCode == 5){
    console.log("got into uae pass testing")
    await User?.uaeGetConfig();
      const uaePasslogoutURL = logoutUaePassUrl(User?.uaePassConfigDetails);
      window.open(uaePasslogoutURL, "_self");
  }
  else{
    navigate("/dashboard");
  }
}

  useEffect(() => {
    if (orderIDParam) {
      const userOtpData: any = localStorage.getItem("otpData");
      const premoseData: any = localStorage.getItem("premiseData");
      const isOwner: any = localStorage.getItem("isOwner");
      const otpData = JSON.parse(userOtpData);
      const premiseData = JSON.parse(premoseData)
      setOwner(isOwner == "true" ? true : false)
      if (User?.info?.personId) {
        General?.initializeUserOtpData(null, premiseData);
      } else {
        const type: any = localStorage.getItem("type");
        const eid: any = localStorage.getItem("largeId");
        const btype: any = localStorage.getItem("businessType");
        setBusinessType(btype)
        setType(type)
        setPersonLargeId(eid)
        General?.initializeUserOtpData(otpData, premiseData);
      }

      User?.info?.personId ? setValue(1) : setValue(2);
      User?.info?.personId ? localStorage.setItem('TabValue', '1') : localStorage.setItem('TabValue', '2');
    }
    return;
  }, []);
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  useEffect(() => {
    function handleResize() {
      setIsLargeScreen(window.innerWidth > 991);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    localStorage.removeItem('premise');
    localStorage.removeItem('general');
  }, [])
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  return (
    <div
      style={{
        backgroundColor: value==3?"": contrast?.contrastBackground
          ? contrast?.contrastBackground
          : "#fff",
      }}
    >
      {/* <ToastContainer/> */}
      <MoveInHeader
        style={{
          color: General.contrast.contrastColor
            ? General.contrast.contrastColor
            : '#fff',
          background: General.contrast.contrastBackground
            ? General.contrast.contrastBackground
            : ColorAss === '#101E8E' ? '#62aa51' : General?.ColorAss
        }}
      >
        <div>
          <MiniNav>
            <ButtonSecondary
              style={{
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss === '#101E8E' ? '#62aa51' : General?.ColorAss,
                width: "81px",
                height: "30px",
                border: "1px solid #FFF",
                fontSize: `${General.accessibility.fontSize}rem`,
                zIndex: '0'
              }}
              onClick={handleBackClick}
            >
              {General?.codeLabels["cm_back"]?.label ? General?.codeLabels["cm_back"]?.label : "BACK"}
            </ButtonSecondary>
            {User?.info?.personId && <ButtonSecondary
              style={{
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastColor
                  : General?.ColorAss === '#101E8E' ? '#62aa51' : General?.ColorAss,
                width: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode == "ARA" ? "12rem" : "117px",
                height: "30px",
                border: "1px solid #FFF",
                fontSize: `${General.accessibility.fontSize}rem`,
                zIndex: '0'
              }}
              onClick={() => navigate("/dashboard")}
            >

              {General?.codeLabels["cm_dashboard"]?.label ? General?.codeLabels["cm_dashboard"]?.label : "DASHBOARD"}
            </ButtonSecondary>}
          </MiniNav>
          <h1
            style={{
              fontFamily: "Segoe UI",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: isLargeScreen ? `${3.1 * General.accessibility.fontSize}rem` : `${2 * General.accessibility.fontSize}rem`,
              margin: "0",
              color: contrast?.contrastColor ? contrast?.contrastColor : "",
            }}
          >
            {User?.info?.personId ? General?.codeLabels["cm_movein"]?.label ? General?.codeLabels["cm_movein"]?.label : "Move In" : headerState == "moveInReg_tenant" ? General?.codeLabels["cm_registration_movein"]?.label ? General?.codeLabels["cm_registration_movein"]?.label : "Move In (Tenancy Registration)" : headerState == "registration_owner" ? General?.codeLabels["cm_registration_owner"]?.label ? General?.codeLabels["cm_registration_owner"]?.label : "Owner Registration" : headerState == "registration_tenant" ? General?.codeLabels["cm_registration_tenant_head"]?.label ? General?.codeLabels["cm_registration_tenant"]?.label : "Tenant Registration" : General?.codeLabels["cm_registration_movein"]?.label ? General?.codeLabels["cm_registration_movein"]?.label : "Move In (Tenancy Registration)"}
            { }
          </h1>
        </div>
      </MoveInHeader>
      {!otpModalOpen && (
        <ComplaintContainer
          style={{
            backgroundColor: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "#fff",
              marginTop:value==3?"1rem":""
          }}
        >
          <Box
            sx={{ width: value === 3 ? "100%" : isLargeScreen ? "80%" : "100%", paddingTop:value==3?'0rem': "2.5rem" }}
          >
            {value != 3 && <Box
              sx={{
                display: "flex",
                // width:isLargeScreen?"":'100vw',
                marginLeft: isLargeScreen ? "" : "1rem",
                justifyContent: General?.isLargeScreen ? "" : 'center'
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                sx={{ alignSelf: "flex-end" }}
                variant="scrollable"
                // scrollButtons
                allowScrollButtonsMobile
              >
                {/*  Property Details Tab */}
                <Tab
                  style={{
                    textTransform: "capitalize",
                    fontSize: `${3.1 * General.accessibility.fontSize}rem`,
                  }}
                  className=""
                  label={
                    <TabWithCount isLargeScreen={isLargeScreen} value={value} count={1}>
                      {isLargeScreen && <span
                        style={{
                          fontSize: `${0.88 * General.accessibility.fontSize
                            }rem`,
                          color: General.contrast.contrastBackground
                            ? General.contrast.contrastBackground
                            : General?.ColorAss,
                        }}
                      //className="DynamicTextColor"
                      >
                        {General?.codeLabels["cm_propertydet"]?.label ? General?.codeLabels["cm_propertydet"]?.label : "Property Details"}
                      </span>}
                    </TabWithCount>
                  }
                  {...a11yProps(0)}
                  sx={{
                    background: General?.isLargeScreen ? contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "#e7e9f8" : "",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#101e8e",
                    margin: "0.2rem",
                    marginBottom: "0",
                    zIndex: "0",
                    "&.Mui-selected": {
                      outline: "none",
                    },
                  }}
                  disabled={value == 1 ? false : true}
                />

                {/* Tenant / Owner Details Tab */}
                <Tab
                  style={{ textTransform: "capitalize" }}
                  label={
                    <TabWithCount count={2} value={value}>
                      {isLargeScreen && <span
                        style={{
                          fontSize: `${0.88 * General.accessibility.fontSize
                            }rem`,
                        }}
                        className="DynamicTextColor"
                      >
                        {General?.codeLabels["cm_registration_property"]?.label ? General?.codeLabels["cm_registration_property"]?.label : "Tenant / Owner Details"}
                      </span>}
                    </TabWithCount>
                  }
                  className=""
                  {...a11yProps(1)}
                  sx={{
                    background: General?.isLargeScreen ? contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "#e7e9f8" : "",
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : "#101e8e",
                    margin: "0.2rem",
                    marginBottom: "0",
                    zIndex: "0",
                    "&.Mui-selected": {
                      outline: "none",
                    },
                  }}
                  disabled={value == 2 ? false : true}
                />

                {/* Movin Information Tab */}

                {!User?.info?.personId && (
                  <Tab
                    style={{ textTransform: "capitalize" }}
                    label={
                      <TabWithCount count={3} value={value}>
                        {isLargeScreen && <span
                          style={{
                            fontSize: `${0.88 * General.accessibility.fontSize
                              }rem`,
                          }}
                          className="DynamicTextColor"
                        >

                          {General?.codeLabels["cm_registration_information"]?.label ? General?.codeLabels["cm_registration_information"]?.label : "Move In Information"}
                        </span>}
                      </TabWithCount>
                    }
                    className=""
                    {...a11yProps(2)}
                    sx={{
                      background: General?.isLargeScreen ? contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "#e7e9f8" : "",
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : "#101e8e",
                      margin: "0.2rem",
                      marginBottom: "0",
                      zIndex: "0",
                    }}
                    disabled={value == 3 ? false : true}
                  />
                )}

                {/* {User?.info?.personId && (
                  <Tab
                    style={{ textTransform: "capitalize" }}
                    label={
                      <TabWithCount count={3} value={value}>
                        {isLargeScreen&& <span
                          style={{
                            fontSize: `${
                              0.88 * General.accessibility.fontSize
                            }rem`,
                          }}
                          className="DynamicTextColor"
                        >

                          {General?.codeLabels["cm_verify_pay"]?.label?General?.codeLabels["cm_verify_pay"]?.label:"Verify & Pay"}
                        </span>}
                      </TabWithCount>
                    }
                    className=""
                    {...a11yProps(2)}
                    sx={{
                      background:General?.isLargeScreen? contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "#e7e9f8":"",
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : "#101e8e",
                      margin: "0.2rem",
                      marginBottom: "0",
                      zIndex: "0",
                    }}
                    disabled={value == 2 ? false : true}
                  />
                )} */}
              </Tabs>
            </Box>}

            {/* Property Details panel  */}

            <TabPanel value={value} index={0}>
              <Property
                premise={General.premise}
                checkOwner={checkOwner}
                checkTenant={checkTenant}
                onClick={handleGetDetails}
                loading={loading}
                disabledBtn={disabledBtn}
                ownerLoading={ownerLoader}
                tenantLoader={tenantLoader}
                Next={() => { setValue(1); localStorage.setItem('TabValue', '1') }}
                sewerageRef={sewerageNumberRef}
                ownerButton={User?.profile?.personId ? false : true}
                handleGetDetails={handleGetDetails}
                attempts={attempts}
                setAttempts={setAttempts}
                isRecaptchaVerified={isRecaptchaVerified}
                setIsRecaptchaVerified={setIsRecaptchaVerified}
                setCaptchaToken={setCaptchaToken}
                resetCaptcha={captchareset} 
                showDetails={proceedToShowDetails}
              />
            </TabPanel>

            {/* tenant / owner details panel */}

            <TabPanel value={value} index={1}>
              <Output
                Owner={owner}
                saveloader={saveloader}
                Submit={ownerContine}
                Previous={() => {
                  General?.handleBackClick();
                  setValue(0);
                  localStorage.removeItem('TabValue')
                  setIsRecaptchaVerified(false);
                }}
                premise={General.premise}
              />
            </TabPanel>

            {/*  Movin information panel */}

            {!User?.info?.personId && (
              <TabPanel value={value} index={2} width="100%">
                <Info
                  owner={owner}
                  registerLoader={registerLoader}
                  userValidatedDetails={MoveInOut.userValidatedDetails}
                  type={moveInType}
                  bType={businessType}
                  premise={General.premise}
                  personLargeId={personLargeId}
                  Submit={handleMoveInRegister}
                  setNewMobileNum={setNewMobileNum}
                  uaePassSubmit={handleMoveInRegisterWithUaePass}
                  // submitRegisterLogedOutOwner={submitRegisterLogedOutOwner}today
                  // moveIn={handleMoveIn}today
                  submitDoc={handleSubmitDoc}
                  Previous={() => {
                    General?.handleBackClick();
                    setValue(0);
                    localStorage.removeItem('TabValue')
                  }}
                />
              </TabPanel>
            )}

            <TabPanel value={value} index={3} width="100%">
              <Thankyou
                title={messageTitle ? messageTitle : "MoveIn Application"}
                referenceId={orderId}
                serviceID={5}
                orderIdRegister={register}
              />
            </TabPanel>
            {User?.info?.personId &&
              <TabPanel value={value} index={2} width="100%">
                {config?.isCheckout ?(
                  <CardsPopup
                  onClose={()=>{setValue(0)}}
                  makePayment={handleMoveInPayment}
                  fromAutoPay={false}
                  amount={MoveInOut.paymentDetails.totalAmount}
                  paymentLoader={paymentLoader}
                  emailForm={true}
                />
                ):(
                <Modal
              open={openCard}
               onClose={(event, reason) => {
                    if (reason === "backdropClick") return;
                    setValue(0);
                    setOpenCard(false)
                  }}
                disableEscapeKeyDown
              >              
                <div className="p-4">
                  <GatewaySelection
                  onClose={()=>{setValue(0)}}
                  paymentData ={paymentDataForGateway}                  
                  handlePayment={handlePaymentInitiation}
                  user={User} 
                  checkTabbyEligibility={checkTabbyEligibility}
                  checkTamaraEligibility={checkTamaraEligibility}

                  />
                </div></Modal>
              )}

              </TabPanel>}
          </Box>
        </ComplaintContainer>
      )}
      <ComplaintContainer
        style={{
          backgroundColor: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "#fff",
        }}
      >
        {/* <Box sx={{ width: value === 3 ? "100%" : "80%", paddingTop: "2.5rem" }}> */}
        <Box sx={{ display: "flex" }}>
          {otpModalOpen && (
            <VerifyAndPay
            registrationLoader={registerLoader}
              premiseId={General.premise.premiseId}
              email={
                // newEmailId ? newEmailId : null
                owner
                  ? General.premise.ownerAccount?.email
                  : General.premise.tenantAccount?.email ? General.premise.tenantAccount?.email : newEmailId? newEmailId : null
              }
              mobile={
                // newMobileNum ? newMobileNum : null
                owner
                  ? General.premise.ownerAccount?.phoneNumber

                  : General.premise.tenantAccount?.phoneNumber ? General.premise.tenantAccount?.phoneNumber : newMobileNum ? newMobileNum : null
              }
              personID={
                owner
                  ? General.premise.ownerAccount?.personID
                  : General.premise.tenantAccount?.personID ? General.premise.tenantAccount?.personID : MoveInOut?.userValidatedDetails?.personId
              }
              onClose={handleOtpModalClose}
              onVerify={setValueToMoveInInfo}
              isModal={false}
              isMovein={true}
              Previous={() => {
                General?.handleBackClick();
                setValue(0)
                localStorage.setItem('TabValue', '0')
                setOTPModalOpen(false);
                setIsRecaptchaVerified(false);
              }}
            />
          )}
        </Box>
        {/* </Box> */}
      </ComplaintContainer>


      <Modal
        sx={{ '--bg-color': ColorAss ? ColorAss : 'pink' }}
        open={showPendingOrderDialog}
        onClose={handleTypeModalClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <PendingOrderModal closeModal={() => setShowPendingOrderDialog(false)} />
      </Modal>
      <Modal
        open={openPendingDue}
        onClose={handleTypeModalClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <PendingDuesModal payNow={() => {
          setOpenCards(true);
          setOpenPendingDue(false);
        }} closeModal={handleClosePendingDue} />
      </Modal>
      <Modal
        open={isUserExist}
        onClose={handleTypeModalClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <UserExistModal onValidateClick={() => {
          navigate('/');
          localStorage.removeItem('value');
        }} />
      </Modal>
      <Modal
        open={typeModalOpen}
        onClose={handleTypeModalClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <TypeModal onClose={handleTypeModalClose} validateLoader={validateLoader} setValidateLoader={setValidateLoader} onValidateClick={onClickTypeValidate} />
      </Modal>
      <Modal
        open={openCards}
        onClose={(event, reason) => {
                    if (reason === "backdropClick") return;
                    handleCardsModalClose();
                  }}
      // onClick={handleClose}
      disableEscapeKeyDown
      >
         {config?.isCheckout ?( <CardsPopup
          onClose={handleCardsModalClose}
          makePayment={handleMoveInPayment}
          fromAutoPay={false}
          amount={MoveInOut.paymentDetails.totalAmount}
          paymentLoader={paymentLoader}
          emailForm={true}
        />):(<div className="p-4">
                  <GatewaySelection
                  onClose={handleCardsModalClose}
                  paymentData ={paymentDataForGateway}                  
                  handlePayment={handlePaymentInitiation}
                  emailForm={true}
                  user={User} 
                  checkTabbyEligibility={checkTabbyEligibility}
                  checkTamaraEligibility={checkTamaraEligibility}
                  />
                </div>)}
        
      </Modal>
      <Modal
        open={loginModal}
        onClose={() => setLoginModal(false)}
      // onClick={handleClose}
      >
        <LoginModal onClose={() => setLoginModal(false)} owner={owner} premise={General.premise} userValidatedDetails={MoveInOut.userValidatedDetails} />
      </Modal>
    </div>
  );
};

export default observer(MoveInRegistration);


